import { combineReducers } from '@reduxjs/toolkit';
import batchDefinitionParametersSlice from 'ducks/bacth-definition-parameters/slices';
import batchDefinitionSlice from 'ducks/batch-definition/slices';
import batchDefinitionDepSlice from 'ducks/batch-definition-dep/slices';
import batchDefinitionListSlice from 'ducks/batch-definition-list/slices';
import batchDefinitionsSlice from 'ducks/batch-definitions/slices';
import batchParametersSlice from 'ducks/batch-parameters/slices';
import batchesSlice from 'ducks/batches/slices';
import containerSlice from 'ducks/container/slices';
import containerStateListSlice from 'ducks/container-states-list/slices';
import containersSlice from 'ducks/containers/slices';
import cpuArchitecturesListSlice from 'ducks/cpu-architectures-list/slices';
import fileSlice from 'ducks/file/slices';
import fileStatesListSlice from 'ducks/file-states-list/slices';
import intervalsListSlice from 'ducks/intervals-list/slices';
import jobSlice from 'ducks/job/slices';
import jobDefinitionSlice from 'ducks/job-definition/slices';
import jobDefinitionParametersSlice from 'ducks/job-definition-parameters/slices';
import jobDefinitionsSlice from 'ducks/job-definitions/slices';
import jobParametersSlice from 'ducks/job-parameters/slices';
import jobStatesListSlice from 'ducks/job-states-list/slices';
import jobsSlice from 'ducks/jobs/slices';
import locationGroupsListSlice from 'ducks/location-groups-list/slices';
import locationsListSlice from 'ducks/locations-list/slices';
import logsSlice from 'ducks/logs/slices';
import maxResultsListSlice from 'ducks/max-results-list/slices';
import modalsSlice from 'ducks/modals/slices';
import parameterSlice from 'ducks/parameter/slices';
import parameterDirectionsListSlice from 'ducks/parameter-directions-list/slices';
import parameterMethodsListSlice from 'ducks/parameter-methods-list/slices';
import parametersSlice from 'ducks/parameters/slices';
import preventPreemptionsListSlice from 'ducks/prevent-preemptions-list/slices';
import projectSlice from 'ducks/project/slices';
import projectParametersSlice from 'ducks/project-parameters/slices';
import projectsSlice from 'ducks/projects/slices';
import referenceTypesListSlice from 'ducks/reference-types-list/slices';
import resultMethodsListSlice from 'ducks/result-methods-list/slices';
import scheduledBatchSlice from 'ducks/scheduled-batch/slices';
import scheduledBatchHistorySlice from 'ducks/scheduled-batch-history/slices';
import scheduledBatchParametersSlice from 'ducks/scheduled-batch-parameters/slices';
import scheduledBatchesSlice from 'ducks/scheduled-batches/slices';
import scrollSlice from 'ducks/scroll/slices';
import settingsSlice from 'ducks/settings/slices';
import standardOutSlice from 'ducks/standard-out/slices';
import systemParametersListSlice from 'ducks/system-parameters-list/slices';
import userSlice from 'ducks/user/slices';

const appReducer = combineReducers({
  batch_definition_dep: batchDefinitionDepSlice,
  batch_definition: batchDefinitionSlice,
  batch_definitions: batchDefinitionsSlice,
  batches: batchesSlice,
  container: containerSlice,
  containers: containersSlice,
  file: fileSlice,
  job: jobSlice,
  job_definition: jobDefinitionSlice,
  job_definitions: jobDefinitionsSlice,
  jobs: jobsSlice,
  logs: logsSlice,
  modals: modalsSlice,
  parameter: parameterSlice,
  parameters: parametersSlice,
  project: projectSlice,
  projects: projectsSlice,
  project_parameters: projectParametersSlice,
  scheduled_batch: scheduledBatchSlice,
  scheduled_batches: scheduledBatchesSlice,
  scroll: scrollSlice,
  settings: settingsSlice,
  standard_out: standardOutSlice,
  user: userSlice,
  prevent_preemptions_list: preventPreemptionsListSlice,
  max_results_list: maxResultsListSlice,
  file_states_list: fileStatesListSlice,
  job_states_list: jobStatesListSlice,
  parameter_directions_list: parameterDirectionsListSlice,
  parameter_methods_list: parameterMethodsListSlice,
  reference_types_list: referenceTypesListSlice,
  result_methods_list: resultMethodsListSlice,
  container_states_list: containerStateListSlice,
  location_list: locationsListSlice,
  cpu_architectures_list: cpuArchitecturesListSlice,
  location_groups_list: locationGroupsListSlice,
  system_parameters_list: systemParametersListSlice,
  intervals_list: intervalsListSlice,
  scheduled_batch_history: scheduledBatchHistorySlice,
  batch_definition_list: batchDefinitionListSlice,
  scheduled_batch_parameters: scheduledBatchParametersSlice,
  job_parameters: jobParametersSlice,
  job_definition_parameters: jobDefinitionParametersSlice,
  batch_parameters: batchParametersSlice,
  batch_definition_parameters: batchDefinitionParametersSlice,
});

export default appReducer;
